import React from "react";
import * as Sentry from "@sentry/react";
import { withRouter } from "react-router-dom";
import CustomErorPage from "components/CustomErrorPage";

/**
 * Renders the same UI as the `/error` route without navigating there. Redirecting
 * to `/error` caused URL churn with MFA/home redirects and could leave users on
 * `/error` after a transient render failure.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    Sentry.captureException(error);
  }
  componentDidUpdate(prevProps) {
    if (
      this.state.hasError &&
      prevProps.location?.pathname !== this.props.location?.pathname
    ) {
      this.setState({ hasError: false });
    }
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="main-wrapper">
          <CustomErorPage />
        </div>
      );
    }
    return this.props.children;
  }
}
export default withRouter(ErrorBoundary);
